import jquery from 'jquery'
window.$ = jquery;